export default {"src":"/_next/static/media/trackchanges.0228f635.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};